<template>
  <div>
    <div
      id="modelInfoModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Help
            </h4>
          </div>
          <div class="modal-body">
            <p>
              <b>Hard lockdown:</b> This is introduced in week 4 and from time
              to time afterwards. Under hard lockdown staff are compelled to
              work from home, up to the maximum possible levels – which vary by
              business sector - and other trip rates are suppressed.
            </p>
            <p>
              <b>Soft lockdown:</b> This persists even when hard lockdown is
              lifted because social distancing rules still apply (see below).
              There is no compulsion to work from home, but this remains a
              voluntary response to conditions on public transport and in
              workplaces.
            </p>
            <p>
              <b>Furloughing:</b> This begins in week 4. Around 25% of staff –
              it varies by business sector – will be furloughed; they no longer
              travel to work, and no longer contribute to GVA (a measure of
              economic output). Furloughing ends in week 28.
            </p>
            <p>
              <b>Social distancing on public transport:</b> This reduces the
              safe carrying capacity of trains and buses. People will alter
              their behaviour – switching to car, walk or cycle, or travelling
              less – to avoid these conditions. The scale of the capacity
              reduction can vary depending on the prevalence of the virus.
            </p>
            <p>
              <b>Social distancing in workplaces:</b> This reduces the safe
              working capacity of workplaces, forcing employers to require staff
              to work from home. Not all staff can do this: the maximum fraction
              of staff who can work from home varies by business sector.
            </p>
            <p>
              <b>Job losses:</b> When furlough ends the model will force between
              3% and 17% of employers to close, depending on the business
              sector.
            </p>
            <p>
              <b>Future workplaces and working from home:</b> Once social
              distancing is lifted people can return to work. However, working
              from home remains popular, and employers allow a proportion of
              their staff to continue to do this. As a result, they require
              smaller premises.
            </p>
            <p>
              <b>Public confidence:</b> When this is low, people are quick to
              reduce their travel and slow to revert to their earlier behaviour.
              It varies over time according to the chosen scenario, but you can
              test the effect of raising it back to ‘normal’.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import "bootstrap";

export default {
  created() {
    this.$root.$data.eventHub.$on("show-modelinfo-modal", this.displayModal);
  },
  methods: {
    displayModal: function() {
      $("#modelInfoModal").modal("show");
    }
  }
};
</script>

<style lang="scss">
#modelInfoModal .modal-dialog {
  width: 80%;
}
#modelInfoModal {
  .modal-body li {
    list-style-type: none;
    margin: 10px 0;
    padding: 0;
  }
  .modal-body ul {
    margin: 0;
    padding: 0;
  }
  .modal-body p {
    margin: 20px 0;
    text-align: justify;
  }
}
</style>
